import { render, staticRenderFns } from "./CoreSkill.vue?vue&type=template&id=8a0c1546&scoped=true&"
import script from "./CoreSkill.vue?vue&type=script&lang=js&"
export * from "./CoreSkill.vue?vue&type=script&lang=js&"
import style0 from "./CoreSkill.vue?vue&type=style&index=0&id=8a0c1546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c1546",
  null
  
)

export default component.exports